import React from "react";
import { Testimonial } from "@/types/testimonial";
import Image from "next/image";

const starIcon = (
  <svg width="18" height="16" viewBox="0 0 18 16" className="fill-current">
    <path d="M9.09815 0.361679L11.1054 6.06601H17.601L12.3459 9.59149L14.3532 15.2958L9.09815 11.7703L3.84309 15.2958L5.85035 9.59149L0.595291 6.06601H7.0909L9.09815 0.361679Z" />
  </svg>
);

const SingleTestimonial = ({
  testimonial,
  onVideoPlay, // Add this prop
  onVideoPause,
}: {
  testimonial: Testimonial;
  onVideoPlay: () => void; // Define the prop type
  onVideoPause: () => void;
}) => {
  const { star, name, image, content, designation, video } = testimonial;

  let ratingIcons: JSX.Element[] = [];
  if (star) {
    for (let index = 0; index < star; index++) {
      ratingIcons.push(
        <span key={index} className="text-yellow">
          {starIcon}
        </span>,
      );
    }
  }

  return (
    <div className="w-full">
      <div
        className="wow fadeInUp rounded-sm bg-liwhite p-8 shadow-two duration-300 hover:shadow-one dark:bg-darkblue dark:shadow-three dark:hover:shadow-darkblue lg:px-5 xl:px-8"
        data-wow-delay=".1s"
        style={{ height: "580px", overflow: "hidden" }}
      >
        {video ? (
          <div className="relative h-[260px] w-full overflow-hidden">
            <video
              controls
              playsInline
              preload="metadata"
              className="h-3/4 w-full object-contain mt-5"
              onPlay={onVideoPlay}
              onPause={onVideoPause}
              onError={(e) => console.error("video load error:", e)}
            >
              <source src={video} type={typeof video === "string" && video.endsWith(".mp4") ? "video/mp4" : "video/webm"} />
              Your browser does not support the video tag.
            </video>
          </div>
        ) : (
          <div className="flex justify-center">
            <div className="mt-8 mb-14 relative h-[170px] w-full max-w-[170px] overflow-hidden">
              {image && typeof image === "string" && image.trim().length > 0 ? (
                <div className="relative h-[170px] w-full max-w-[200px] overflow-hidden rounded-full">
                  <Image src={image} alt={name || "testimonial"} fill sizes="170px" />
                </div>
              ) : (
                <div className="animate-pulse h-[170px] w-[170px] bg-slate-200 rounded-full" />
              )}
            </div>
          </div>
        )}
        <div className="text-center">
        {!video && (
          <>
            <h3 className="mb-1 text-lg font-semibold text-dark dark:text-white lg:text-base xl:text-lg">
              {name}
            </h3>
            <p className="text-sm text-body-color">{designation}</p>
            <div className="mb-2 flex items-center justify-center space-x-1">
              {ratingIcons}
            </div>
          </>
        )}
        </div>
        <div className="text-center">
          {video && (
            <>
              <h3 className="text-lg font-semibold text-dark dark:text-white">
                {name}
              </h3>
              <p className="text-sm text-body-color">{designation}</p>
              <div className="mb-2 flex items-center justify-center space-x-1">
                {ratingIcons}
              </div>
            </>
          )}
          <p
            className="border-b border-body-color border-opacity-10 pb-8 text-base leading-relaxed text-body-color dark:border-white dark:border-opacity-10 dark:text-white"
            style={{ maxHeight: "190px", overflowY: "auto" }}
          >
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SingleTestimonial;
